// extracted by mini-css-extract-plugin
export default {"logo":"MainNavigation_logo__SUaEL"};